export const TEAMS_LOADING_MESSAGE = 'Loading your teams, just a moment';
export const MEMBERS_LOADING_MESSAGE = 'Loading members, just a moment';
export const GENERIC_LOADING_MESSAGE = 'Loading, please wait';
